export default {"src":"/_next/static/media/app-store_badge_id.34ce36ec.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};